import styled from "styled-components";

export const Content = styled.div``;

export const Container = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0;
  
  .submit {
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e3f2fd;
    display: flex;
    justify-content: flex-end;
    
    .submit-buttons {
      display: flex;
      gap: 12px;
      
      .cancel,
      .add-campaign {
        padding: 12px 24px;
        height: 44px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .cancel {
        color: #546881;
        border: 2px solid #e3f2fd;
        
        &:hover {
          border-color: #03a9f4;
          color: #03a9f4;
        }
      }
      
      .add-campaign {
        color: #fff;
        border: 2px solid #03a9f4;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        box-shadow: 0 2px 8px rgba(3, 169, 244, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(3, 169, 244, 0.4);
        }
        
        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }
  }

  @media screen and (max-width: 820px) {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  margin-bottom: 30px;
  padding: 25px 0;
  border-bottom: 1px solid #e3f2fd;
  
  &:last-of-type {
    border-bottom: none;
  }
  
  label {
    display: block;
    margin-bottom: 10px;
    color: #1a237e;
    font-size: 14px;
    font-weight: 600;
  }
  
  p {
    margin-top: 5px;
    margin-bottom: 15px;
    font-size: 13px;
    color: #546881;
    line-height: 1.5;
  }
  
  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    margin-top: 10px;
    border: 2px solid #e3f2fd;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #1a237e;
    background: #ffffff;
    transition: all 0.3s ease;
    &:focus {
      outline: none;
      border-color: #03a9f4;
      box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
    }
    
    &::placeholder {
      color: #98a2b3;
    }
  }
`;

export const RadioGroup = styled.div`
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  padding: 10px 16px 24px 16px;
`;

export const RadioButton = styled.input`
  display: none;

  &:checked + label {
    background-color: #eefffc;
    border-color: #03a9f4;
    .circle {
      background-color: #03a9f4;
      img {
        display: block;
        width: 8px;
        height: 10px;
        margin: auto;
        margin-top: 2px;
        transform: scale(1);
        justify-content: center;
        align-items: center;
      }
    }
  }

  &:disabled + label {
    color: #ccc;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  .label-name {
    display: flex;
    gap: 10px;
    p {
      margin-top: 5px;
    }
  }
  img {
    width: 28px;
    height: 28px;
  }
  .circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    margin-right: 10px;
    transition: background-color 0.2s ease-in-out;
    img {
      display: none;
    }
  }
`;

export const ProofOfPaymentContainer = styled.div`
  border: 2px dashed #03a9f4;
  padding: 40px 20px;
  text-align: center;
  border-radius: 12px;
  background: #f8fbff;
  transition: all 0.3s ease;
  margin-top: 10px;
  
  &:hover {
    border-color: #0288d1;
    background: #e3f2fd;
  }
`;

export const FileInputLabel = styled.label`
  display: block;
  cursor: pointer;
  
  .text {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: #546881;
    
    img {
      opacity: 0.6;
    }
    
    p {
      font-size: 14px;
      font-weight: 500;
      color: #03a9f4;
      margin: 0;
    }
    
    small {
      font-size: 12px;
      color: #98a2b3;
    }
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(3, 169, 244, 0.15);
`;

export const Details = styled.div`
  width: 100%;
  padding: 30px;
  background: #ffffff;
  border: 2px solid #e3f2fd;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  margin-top: 10px;
  
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #e3f2fd;
    
    &:last-child {
      border-bottom: none;
    }

    label {
      font-size: 13px;
      color: #546881;
      line-height: 20px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    p {
      font-size: 15px;
      color: #1a237e;
      line-height: 22px;
      font-weight: 600;
      margin: 0;
    }
    img {
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;
